import styled from 'styled-components'

export const Card = styled.div`
  border: ${({ theme }) => theme.card.border};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  background: ${({ theme }) => theme.card.background};
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  padding: 20px;
`
